import React from 'react';
import { TextField, InputAdornment } from '@mui/material';
import { Icons } from '../../Icons/Icons';

interface SearchFieldProps {
  searchText: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  inputRef: React.RefObject<HTMLInputElement>;
}

export const SearchField: React.FC<SearchFieldProps> = ({ searchText, onChange, inputRef }) => (
  <TextField
    fullWidth
    inputRef={inputRef}
    size="small"
    placeholder="Search..."
    value={searchText}
    onChange={onChange}
    InputProps={{
      startAdornment: (
        <InputAdornment position="start">
          <div className="search-icon">{Icons.Search}</div>
        </InputAdornment>
      ),
    }}
  />
);
